module.exports = __webpack_public_path__ + "media/images/icon_youtube-2db4f8c5f9904f9206ed1e2cf173bfec.svg";